import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': 'Langue',
  'common.download.action': 'Télécharger',
  'common.store.appleprefix': 'Télécharger dans',
  'common.store.googleprefix': 'DISPONIBLE SUR',
  'seo.home.title': 'Happy Pets | Compagnon IA, tests et widgets',
  'seo.home.description': 'Découvrez un animal virtuel avec IA pour réfléchir, explorer votre personnalité, consulter tarot et rêves, utiliser des widgets et l’élever avec des amis.',
  'seo.home.keywords': 'Happy Pets, compagnon IA, animal virtuel, widget, test de personnalité, MBTI, tarot IA',
  'seo.invite.title': 'Invitation Happy Pets | Élevez un animal à plusieurs',
  'seo.invite.description': 'Ouvrez votre invitation Happy Pets pour adopter ou élever un animal virtuel avec vos amis sur iPhone et Android.',
  'nav.skills.label': 'Compétences',
  'nav.tests.label': 'Tests',
  'nav.guidance.label': 'Guidance IA',
  'nav.features.label': 'Fonctions',
  'nav.experience.label': 'Expérience',
  'nav.community.label': 'Communauté',
  'nav.news.label': 'Actualités',
  'home.hero.titlelead': 'Un petit animal,',
  'home.hero.titleaccent': 'un peu d’aide chaque jour',
  'home.hero.subtitle': 'Adoptez un animal virtuel chaleureux qui vit sur votre écran, grandit avec vous et apprend des compétences utiles pour vous aider, vous divertir et vous accompagner.',
  'home.tools.eyebrow': 'Compétences de votre animal',
  'home.tools.title': 'Les petites choses du quotidien qu’il peut vous aider à faire',
  'home.tools.description': 'Faites de votre animal un compagnon utile pour réfléchir, trouver des idées de repas, mieux vous connaître et prendre de petites décisions.',
  'home.tools.action': 'Essayer',
  'tool.tarot.tag': 'Réflexion',
  'tool.tarot.title': 'Tarot',
  'tool.tarot.description': 'Laissez votre animal tirer une carte et vous aider à voir votre question sous un autre angle.',
  'tool.mbti.tag': 'Personnalité',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Explorez votre type, comparez vos habitudes et découvrez comment vous pensez et créez des liens.',
  'tool.chef.tag': 'Cuisine',
  'tool.chef.title': 'Chef du frigo',
  'tool.chef.description': 'Transformez les ingrédients déjà présents dans votre frigo en repas simples avec votre petit chef.',
  'tool.fortune.tag': 'Quotidien',
  'tool.fortune.title': 'Chance du jour',
  'tool.fortune.description': 'Commencez la journée avec un aperçu léger de votre humeur, de votre chance et des petits moments à venir.',
  'tool.calorie.tag': 'Santé',
  'tool.calorie.title': 'Calculateur de calories',
  'tool.calorie.description': 'Estimez les calories, repérez vos habitudes alimentaires et choisissez vos repas plus simplement.',
  'tool.dream.tag': 'Rêves',
  'tool.dream.title': 'Interprétation des rêves',
  'tool.dream.description': 'Votre animal organise les symboles de la nuit et transforme les fragments flous en pistes de réflexion.',
  'home.assessments.eyebrow': 'Mieux vous connaître',
  'home.assessments.title': 'Des tests de découverte de soi aux résultats à explorer',
  'home.assessments.description': 'Faites un test de personnalité, raisonnement, carrière ou relation, puis discutez du résultat avec votre compagnon IA.',
  'home.assessments.action': 'Commencer le test',
  'home.assessments.disclaimer': 'Ces tests servent à la découverte de soi et au divertissement. Ils ne remplacent ni diagnostic médical ni conseil professionnel.',
  'assessment.mbti.eyebrow': 'Personnalité',
  'assessment.mbti.title': 'Test de personnalité MBTI',
  'assessment.mbti.description': 'Explorez vos préférences, votre communication, vos forces et vos schémas de progression.',
  'assessment.mbti.meta': '108 questions',
  'assessment.sbti.eyebrow': 'Style social',
  'assessment.sbti.title': 'Test de personnalité SBTI',
  'assessment.sbti.description': 'Découvrez comment vous êtes avec les autres grâce à cinq dimensions ludiques liées aux émotions, aux actions et à l’énergie sociale.',
  'assessment.sbti.meta': '62 questions',
  'assessment.iq.eyebrow': 'Raisonnement',
  'assessment.iq.title': 'Évaluation du raisonnement IQ',
  'assessment.iq.description': 'Résolvez des suites non verbales et comparez différents domaines du raisonnement.',
  'assessment.iq.meta': 'Raisonnement visuel',
  'assessment.holland.eyebrow': 'Carrière',
  'assessment.holland.title': 'Intérêts professionnels Holland',
  'assessment.holland.description': 'Repérez les activités et environnements professionnels qui pourraient vous convenir parmi six thèmes.',
  'assessment.holland.meta': 'Intérêts professionnels',
  'assessment.attachment.eyebrow': 'Relations',
  'assessment.attachment.title': 'Test du style d’attachement',
  'assessment.attachment.description': 'Réfléchissez à la proximité, la confiance, la sécurité et l’indépendance pour mieux comprendre vos relations.',
  'assessment.attachment.meta': 'Éclairage relationnel',
  'home.guidance.eyebrow': 'Un doux rituel quotidien',
  'home.guidance.title': 'Une guidance mystique par IA ancrée dans la réflexion',
  'home.guidance.description': 'Le tarot, la chance du jour et les symboles des rêves vous invitent à ralentir, nommer vos émotions et trouver une prochaine étape réaliste. Il ne s’agit pas de prédire l’avenir, mais de gagner en clarté et en calme.',
  'guidance.tarot.title': 'Tarot IA',
  'guidance.tarot.description': 'Choisissez des cartes autour d’une question et utilisez la lecture comme une douce invitation à réfléchir et changer de perspective.',
  'guidance.tarot.note': 'Pour réfléchir et se divertir',
  'guidance.fortune.title': 'Chance du jour',
  'guidance.fortune.description': 'Commencez la journée avec un regard léger sur l’humeur, l’énergie, la chance et des encouragements pratiques.',
  'guidance.fortune.note': 'Une nouvelle guidance chaque jour',
  'guidance.dream.title': 'Interprétation des rêves',
  'guidance.dream.description': 'Transformez les images et émotions de vos rêves en thèmes à explorer, sans en faire des prédictions.',
  'guidance.dream.note': 'Symboles, émotions et réflexion',
  'home.features.eyebrow': 'Compétences utiles, joie quotidienne',
  'home.features.title': 'Pourquoi votre animal devient si utile',
  'feature.raise.title': 'Élevez des animaux adorables',
  'feature.raise.description': 'Nourrissez-les, jouez et regardez-les devenir des compagnons mignons, réconfortants et utiles.',
  'feature.hatch.title': 'Faites éclore de nouvelles compétences',
  'feature.hatch.description': 'Collectionnez des œufs et découvrez des animaux uniques avec leurs propres personnalités et compétences.',
  'feature.coraising.title': 'Élevez-les avec vos proches',
  'feature.coraising.description': 'Invitez vos amis à s’en occuper ensemble : deux fois plus d’affection et de plaisir.',
  'feature.status.title': 'État quotidien',
  'feature.status.description': 'Suivez votre état du jour et partagez vos émotions avec votre animal.',
  'feature.frequency.title': 'Fréquence quotidienne',
  'feature.frequency.description': 'Créez vos événements et suivez des habitudes comme boire de l’eau ou courir.',
  'feature.cleaner.title': 'Nettoyeur de photos',
  'feature.cleaner.description': 'Rangez votre galerie en jouant. Amusant et productif.',
  'feature.skills.title': 'Salle de compétences IA',
  'feature.skills.description': 'Débloquez de nouveaux styles et découvrez plus d’aide pour réfléchir, planifier et vivre le quotidien.',
  'feature.widget.title': 'Widget interactif',
  'feature.widget.description': 'Gardez votre animal près de vous grâce aux widgets interactifs de l’écran d’accueil.',
  'home.steps.eyebrow': 'Bien démarrer',
  'home.steps.title': 'Faites éclore un animal aux compétences utiles',
  'step.adopt.title': 'Adoptez',
  'step.adopt.description': 'Choisissez votre œuf unique et commencez l’aventure avec votre propre compagnon.',
  'step.grow.title': 'Grandissez',
  'step.grow.description': 'Nourrissez, jouez et interagissez chaque jour pour l’aider à grandir et apprendre.',
  'step.together.title': 'Ensemble',
  'step.together.description': 'Invitez vos amis et laissez vos animaux partager un monde plein de personnalité et de soutien.',
  'home.reviews.eyebrow': 'Communauté',
  'home.reviews.title': 'Aimé pour bien plus que son côté mignon',
  'home.reviews.role': 'Parent d’animal',
  'home.news.eyebrow': 'Actualités et récits',
  'home.news.title': 'Dernières actualités',
  'home.news.description': 'Des idées douces autour de la vie avec votre compagnon, de la découverte de soi et du bien-être quotidien.',
  'home.news.readarticle': 'Lire l’article',
  'home.news.exploreall': 'Voir toutes les actualités',
  'review.one.text': 'Mon animal est adorable, mais ce qui m’étonne le plus, c’est la fréquence à laquelle j’utilise ses petites compétences.',
  'review.two.text': 'Élever un animal avec mon copain nous apporte beaucoup de joie et ses fonctions sont utiles chaque jour.',
  'review.three.text': 'Les widgets sont très interactifs. J’adore avoir un compagnon mignon qui m’aide aussi au quotidien.',
  'home.footer.tagline': 'Apportez joie et compagnie à votre écran d’accueil.',
  'home.footer.product': 'Produit',
  'home.footer.support': 'Assistance',
  'home.footer.social': 'Réseaux',
  'home.footer.skills': 'Compétences',
  'home.footer.features': 'Fonctions',
  'home.footer.widgets': 'Widgets',
  'home.footer.help': 'Centre d’aide',
  'home.footer.privacy': 'Confidentialité',
  'home.footer.terms': 'Conditions',
  'home.footer.copyright': '© 2024 Happy Pet. Tous droits réservés.',
  'home.image.logoalt': 'Logo Happy Pets',
  'home.image.screenalt': 'Écran de l’application Happy Pets',
  'home.image.enlargedalt': 'Écran Happy Pets agrandi',
  'home.image.close': 'Fermer l’image',
  'invite.headline': 'Vos amis vous invitent à élever un animal ensemble !',
  'invite.description': 'Acceptez l’invitation et l’œuf éclot immédiatement. Ajoutez votre animal à l’écran d’accueil.',
  'invite.download': 'Télécharger',
  'invite.loadingalt': 'Chargement de Happy Pets',
  'invite.screensalt': 'Captures de l’application Happy Pets'
})
